import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ModalComponent } from '@app/shared/components';

@Component({
    selector: 'app-tool-modal',
    templateUrl: './tool-modal.component.html',
    styleUrls: ['./tool-modal.component.scss']
})
export class ToolModalComponent implements OnChanges {

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Input() title: string;
    @Input() tools: any;
    @Input() dismissible = true;
    @Input() isLoading = false;

    @Output() cancelInfoModal = new EventEmitter<any>();


    constructor(private cdr: ChangeDetectorRef) {
    }

    open() {
        this.modal.open();
    }

    close() {
        this.modal.close();
    }

    onCancel() {
        this.cancelInfoModal.emit();
    }

    ngOnChanges(changes: SimpleChanges): void {
    }
}
